import { useAppSelector } from '@hooks';
import { selectIsAuthenticated } from '@store/auth-slice';
import { NextLayoutComponentType } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const withoutAuth = (Component: NextLayoutComponentType) => {
  const Auth = (props: any) => {
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const router = useRouter();

    useEffect(() => {
      if (isAuthenticated) router.push('profile');
    }, [isAuthenticated, router]);

    return <Component {...props} />;
  };

  if (Component.getInitialProps) {
    Auth.getInitialProps = Component.getInitialProps;
  }

  if (Component.getLayout) {
    Auth.getLayout = Component.getLayout;
  }

  return Auth;
};
